export default __webpack_public_path__ + "static/media/1.8181ba71.png";